import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const ActivityGaugeClient = ({ chartData, type }) => {
  // Calculate total client amount from all months
  
  const totalClientAmount = chartData?.monthlyStatus?.reduce(
    (sum, month) => sum + (month.client_paid_amount + month.client_overdue_amount), 
    0
  ) || 0;

  // Calculate total client paid and overdue amounts
  const totalClientPaidAmount = chartData?.monthlyStatus?.reduce(
    (sum, month) => sum + month.client_paid_amount, 
    0
  ) || 0;

  const totalClientOverdueAmount = chartData?.monthlyStatus?.reduce(
    (sum, month) => sum + month.client_overdue_amount, 
    0
  ) || 0;

  // Calculate percentages
  const paidPercentage = totalClientAmount > 0 ? 
    ((totalClientPaidAmount / totalClientAmount) * 100).toFixed(2) : 0;
  
  const overduePercentage = totalClientAmount > 0 ? 
    ((totalClientOverdueAmount / totalClientAmount) * 100).toFixed(2) : 0;

  // Data for the circular progress bars
  const data = [
    {
      label: "Paid",
      value: parseFloat(paidPercentage),
      color: "#69C195", // Green for paid
      amount: totalClientPaidAmount.toLocaleString()
    },
    {
      label: "Overdue",
      value: parseFloat(overduePercentage),
      color: "#F97066", // Red for overdue
      amount: totalClientOverdueAmount.toLocaleString()
    }
  ];

  return (
    <div className="flex items-start gap-4">
      <div style={{ position: "relative", width: "250px", height: "250px" }}>
        {data.map((item, index) => (
          <div
            key={index}
            style={{
              position: "absolute",
              width: "100%",
              height: "100%",
              top: "50%",
              left: "50%",
              transform: `translate(-50%, -50%) scale(${1 - index * 0.20})`, 
              zIndex: data.length - index,
            }}
          >
            <CircularProgressbar
              value={item.value}
              maxValue={100}
              strokeWidth={8} // Controls thickness of the circles
              styles={buildStyles({
                pathColor: item.color,
                trailColor: "#f0f0f0",
                strokeLinecap: "round",
                rotation: 0.25, // Adds slight rotation for better alignment
              })}
            />
          </div>
        ))}

        {/* Center Text */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          <div>{type || "Clients"}</div>
          <div style={{ fontSize: "14px", marginTop: "5px" }}>
            ${totalClientAmount.toLocaleString()}
          </div>
        </div>
      </div>

      {/* Legend */}
      <div className="mt-4 text-center">
        {data.map((item, index) => (
          <div key={index} className="flex items-center justify-start mb-2">
            <span
              style={{
                width: "10px",
                height: "10px",
                backgroundColor: item.color,
                borderRadius: "50%",
                display: "inline-block",
                marginRight: "8px",
              }}
            ></span>
            <span>{item.label}</span>
            <div className="ml-2 text-gray-600 font-semibold text-sm">
              ${item.amount}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityGaugeClient;